// console.log('Version has value ', process.env.REACT_APP_VERSION)

export default process.env.REACT_APP_VERSION
